// extracted by mini-css-extract-plugin
module.exports = {"main":"AdesioneB2CTemplate_main__OzH6c","rotation":"AdesioneB2CTemplate_rotation__DyWh9"};